export const API_LOADER = "API_LOADER";
export const ADD_NEW_ADMIN = "ADD_NEW_ADMIN";
export const EDIT_ADMIN_MIDDLEWARE = "EDIT_ADMIN_MIDDLEWARE";
export const EDIT_ADMIN_DATA = "EDIT_ADMIN_DATA";
export const ADDING_NEW_ADMIN = "ADDING_NEW_ADMIN";
export const NEW_ADMIN_ADDED = "NEW_ADMIN_ADDED";
export const ADD_NEW_ADMIN_ERROR = "ADD_NEW_ADMIN_ERROR";
export const ASSOCIATE_USER = "ASSOCIATE_USER";

export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
export const GETTING_ALL_ADMINS = "GETTING_ALL_ADMINS";
export const SET_ALL_ADMINS = "SET_ALL_ADMINS";
export const GET_ALL_ADMINS_ERROR = "GET_ALL_ADMINS_ERROR";

export const ADD_NEW_ADMIN_JOB = "ADD_NEW_ADMIN_JOB";
export const ADDING_NEW_ADMIN_JOB = "ADDING_NEW_ADMIN_JOB";
export const NEW_ADMIN_JOB_ADDED = "NEW_ADMIN_JOB_ADDED";
export const ADD_NEW_ADMIN_JOB_ERROR = "ADD_NEW_ADMIN_JOB_ERROR";

export const GET_DEALER_DATA = "GET_DEALER_DATA";
export const SET_ALL_DEALER = "SET_ALL_DEALER";
export const ASSOCIATE_DEALER = "ASSOCIATE_DEALER";

export const GET_CERTIFICATE = "GET_CERTIFICATE";
export const CERTIFICATE_DATA_LIST = "CERTIFICATE_DATA_LIST";
export const CERTIFICATE_KEY = "CERTIFICATE_KEY";
export const CERTIFICATE_WISE_STATE_LIST = "CERTIFICATE_WISE_STATE_LIST";

export const GET_RECYCLE_FACTORY_DATA = "GET_RECYCLE_FACTORY_DATA";
export const SET_ALL_RECYCLE_FACTORY = "SET_ALL_RECYCLE_FACTORY";

export const GET_DISPOSAL_CONTRACTOR_DATA = "GET_DISPOSAL_CONTRACTOR_DATA";
export const SET_ALL_DISPOSAL_CONTRACTOR = "SET_ALL_DISPOSAL_CONTRACTOR";

export const GET_TRANSPORT_CONTRACTOR_DATA = "GET_TRANSPORT_CONTRACTOR_DATA";
export const SET_ALL_TRANSPORT_CONTRACTOR = "SET_ALL_TRANSPORT_CONTRACTOR";

export const SET_ALL_ASSOCIATED_RECYCLE_FACTORY = "SET_ALL_ASSOCIATED_RECYCLE_FACTORY";
export const GET_ASSOCIATED_RECYCLE_FACTORY = "GET_ASSOCIATED_RECYCLE_FACTORY";

export const SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR = "SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR";
export const GET_ASSOCIATED_DISPOSAL_CONTRACTOR = "GET_ASSOCIATED_DISPOSAL_CONTRACTOR";

export const GET_REFRIGERANT_DATA = "GET_REFRIGERANT_DATA";
export const SET_ALL_REFRIGERANT = "SET_ALL_REFRIGERANT";

export const GET_CONTRACTOR_DATA = "GET_CONTRACTOR_DATA";
export const SET_ALL_CONTRACTOR = "SET_ALL_CONTRACTOR";

export const SET_ALL_BUILDING = "SET_ALL_BUILDING";
export const GET_BUILDING_DATA = "GET_BUILDING_DATA";

export const GET_CUSTOMER_DATA = "GET_CUSTOMER_DATA";
export const SET_ALL_CUSTOMER = "SET_ALL_CUSTOMER";

export const GET_FILED_ENGINEER_DATA = "GET_FILED_ENGINEER_DATA";
export const SET_ALL_FILED_ENGINEER = "SET_ALL_FILED_ENGINEER";

export const GET_RECYCLE_ENGINEER_DATA = "GET_RECYCLE_ENGINEER_DATA";
export const SET_ALL_RECYCLE_ENGINEER = "SET_ALL_RECYCLE_ENGINEER";

export const GET_DISPOSAL_ENGINEER_DATA = "GET_DISPOSAL_ENGINEER_DATA";
export const SET_ALL_DISPOSAL_ENGINEER = "SET_ALL_DISPOSAL_ENGINEER";

export const SET_USER_WISE_ID = "SET_USER_WISE_ID";

export const GET_USER_OWNED = "GET_USER_OWNED";
export const SET_USER_OWNED = "SET_USER_OWNED";

export const GET_USER_BORROWED = "GET_USER_BORROWED";
export const SET_USER_BORROWED = "SET_USER_BORROWED";

export const GET_USER_LENT = "GET_USER_LENT";
export const SET_USER_LENT = "SET_USER_LENT";

export const GET_USER_100KG = "GET_USER_100KG";
export const SET_USER_100KG = "SET_USER_100KG";

export const GET_USER_20KG = "GET_USER_20KG";
export const SET_USER_20KG = "SET_USER_20KG";
export const SET_PARENT_USER = "SET_PARENT_USER";

export const ADD_NEW_CYLINDER = "ADD_NEW_CYLINDER";
export const ADDING_NEW_CYLINDER = "ADDING_NEW_CYLINDER";
export const NEW_CYLINDER_ADDED = "NEW_CYLINDER_ADDED";

export const VERIFY_NAME = "VERIFY_NAME";
export const VERIFY_NAME_ERROR = "VERIFY_NAME_ERROR";

export const SET_NEW_CYLINDER = "SET_NEW_CYLINDER";

export const GET_NEW_CYLINDER = "GET_NEW_CYLINDER";
export const GET_100KG_CYLINDER_INFO = "GET_100KG_CYLINDER_INFO";
export const SET_100KG_CYLINDER_INFO = "SET_100KG_CYLINDER_INFO";

export const GET_PIN_CODE = "GET_PIN_CODE";
export const SET_PIN_CODE = "SET_PIN_CODE";
export const SET_REPORT_PIN_CODE = "SET_REPORT_PIN_CODE";

export const SET_VERIFY_STATUS = "SET_VERIFY_STATUS";
export const ALL_DATA_ROLE_WISE = "ALL_DATA_ROLE_WISE";

export const GET_NEW_OWNED_CYLINDER_DATA = "GET_NEW_OWNED_CYLINDER_DATA";
export const GET_NEW_BORROWED_CYLINDER_DATA = "GET_NEW_BORROWED_CYLINDER_DATA";
export const GET_NEW_100KG_CYLINDER_DATA = "GET_NEW_100KG_CYLINDER_DATA";

export const SEARCH_CYLINDER_USING_ID = "SEARCH_CYLINDER_USING_ID";
export const SEARCH_GET_CYLINDER_USING_ID = "SEARCH_GET_CYLINDER_USING_ID";

export const GET_CYLINDER_INFO = "GET_CYLINDER_INFO";
export const SET_CYLINDER_INFO = "SET_CYLINDER_INFO";

export const EDIT_CYLINDER_FLAG = "EDIT_CYLINDER_FLAG";

export const CYLINDER_REF_MAP = "CYLINDER_REF_MAP";
export const CYLINDER_REF_DATA_LIST = "CYLINDER_REF_DATA_LIST";

export const GET_ALL_CONTRACTOR_LIST = "GET_ALL_CONTRACTOR_LIST";

export const GET_PARENT_DATA = "GET_PARENT_DATA";
export const SET_PARENT_DATA = "SET_PARENT_DATA";
export const SET_MODEL_PARENT_DATA = "SET_MODEL_PARENT_DATA";
export const SET_CHILD_ASSOCIATE_CONTRACTOR = "SET_CHILD_ASSOCIATE_CONTRACTOR";
export const GET_CHILD_ASSOCIATE_CONTRACTOR = "GET_CHILD_ASSOCIATE_CONTRACTOR";
export const SET_SELECTED_100_KG = "SET_SELECTED_100_KG";

export const GET_RATE_CARD_INFO = "GET_RATE_CARD_INFO";
export const SET_RATE_CARD_INFO = "SET_RATE_CARD_INFO";
export const SET_SERVICES = "SET_SERVICES";
export const GET_SERVICES = "GET_SERVICES";
export const SERVICE_KEY = "SERVICE_KEY";
export const SET_SERVICE_STATE_LIST = "SET_SERVICE_STATE_LIST";
export const SET_SELECTED_SERVICE = "SET_SELECTED_SERVICE";
export const SET_SELECTED_CERTIFICATE = "SET_SELECTED_CERTIFICATE";
export const UPDATE_CERTIFICATE = "UPDATE_CERTIFICATE";
export const UPDATE_CATEGORY_DATA = "UPDATE_CATEGORY_DATA";
export const MODAL_OPEN_CLASS_LIST = "MODAL_OPEN_CLASS_LIST";

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const GET_CHILD_ASSOCIATE_DATA = "GET_CHILD_ASSOCIATE_DATA";
export const RESET_ADMIN_JOB = "RESET_ADMIN_JOB";
export const USER_KEY = "USER_KEY";
export const GET_REGION_LIST = "GET_REGION_LIST";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const GET_ADD_USER_LIST = "GET_ADD_USER_LIST";
export const SET_ADD_USER_LIST = "SET_ADD_USER_LIST";
export const SEARCH_MENU_CYLINDER = "SEARCH_MENU_CYLINDER";
export const SET_EDITED_CYLINDER_TYPE = "SET_EDITED_CYLINDER_TYPE";
export const SET_100KG_BORROWED = "SET_100KG_BORROWED";
export const GET_100KG_BORROWED_CYLINDER_DATA = "GET_100KG_BORROWED_CYLINDER_DATA";
export const GET_100KG_LENT_CYLINDER_DATA = "GET_100KG_LENT_CYLINDER_DATA";
export const SET_100KG_LENT = "SET_100KG_LENT";
export const SET_NON_ASSOCIATE_USERS = "SET_NON_ASSOCIATE_USERS";
export const SEARCH_NON_ASSOCIATE_USERS = "SEARCH_NON_ASSOCIATE_USERS";
export const GET_NON_ASSOCIATE_USERS = "GET_NON_ASSOCIATE_USERS";
export const UPDATE_NON_ASSOCIATE_USERS = "UPDATE_NON_ASSOCIATE_USERS";
export const GET_DEALER_USER_LIST = "GET_DEALER_USER_LIST";
export const SET_DEALER_USER_LIST = "SET_DEALER_USER_LIST";
export const GET_ASSOCIATE_RECYCLER = "GET_ASSOCIATE_RECYCLER";
export const SET_ASSOCIATE_RECYCLER_LIST = "SET_ASSOCIATE_RECYCLER_LIST";
export const GET_ASSOCIATE_PROCESSOR = "GET_ASSOCIATE_PROCESSOR";
export const SET_ASSOCIATE_PROCESSOR_LIST = "SET_ASSOCIATE_PROCESSOR_LIST";
export const GET_ASSOCIATE_DISPOSER = "GET_ASSOCIATE_DISPOSER";
export const SET_ASSOCIATE_DISPOSER_LIST = "SET_ASSOCIATE_DISPOSER_LIST";
export const SET_ASSOCIATE_TRANSPORTER_LIST = "SET_ASSOCIATE_TRANSPORTER_LIST";
export const DELETE_SELECTED_CYLINDER = "DELETE_SELECTED_CYLINDER";
export const SET_VIEW_DETAILS_DATA = "SET_VIEW_DETAILS_DATA";
export const SET_ERROR_RESPONSE = "SET_ERROR_RESPONSE";
export const SET_CYLINDER_NAME = "SET_CYLINDER_NAME";
export const GET_NEW_OWNED_100KG_CYLINDER_DATA = "GET_NEW_OWNED_100KG_CYLINDER_DATA";
export const GET_NEW_BORROWED_100KG_CYLINDER_DATA = "GET_NEW_BORROWED_100KG_CYLINDER_DATA";

export const SET_FILL_CYLINDER_LIST = "SET_FILL_CYLINDER_LIST";
export const SET_UPLOAD_TYPE = "SET_UPLOAD_TYPE";




